import React, {useContext, useEffect, useState} from "react";
import NavButton from "../../components/NavButton/index";
import ContentHeader from "../../components/ContentHeader/index";
import LoaderAnim from "../../components/LoaderAnim/index";
import Divider from "../../components/Divider/index";
import Context, {Actions} from "../../reducers/Context";
import useForm, {FormContext} from "react-hook-form"
import FormInput from "../../components/FormInputs/FormInput";
import useSocialLogin from "../../hooks/useSocialLogin"
import useTeamStatsLogin from "../../hooks/useTeamStatsLogin";
import {API, useDataApi} from "../../components/API";

const LoginMethod = () => {
    const {dispatch, state} = useContext(Context);
    const {socialLogin, socialData, isSocialLoading, isSocialError} = useSocialLogin();
    const {teamStatsLogin, tsData, isTsLoading, isTsError} = useTeamStatsLogin();
    const {data, isLoading, isError, doFetch} = useDataApi("");
    const [userDetails, setUserDetails] = useState({});
    const hookForm = useForm();

    useEffect(() => {
        if (socialData || tsData) {
            const _teamsData = Object.assign({}, socialData, tsData);
            if (_teamsData.teams) {
                dispatch({
                    type: Actions.RECEIVED_USER_TEAMS_DATA,
                    payload: _teamsData
                });
                if (_teamsData.teams.length === 1) {
                    dispatch({
                        type: Actions.SELECTED_TEAM,
                        payload: {team : _teamsData.teams[0]}
                    });
                        doFetch(API.CREATE_SESSION, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({auth: _teamsData.auth, team : _teamsData.teams[0]})
                        });
                }
            } else if (_teamsData.linkAccounts) {
                return dispatch({
                    type: Actions.RECEIVED_LINK_ACCOUNTS_REQUEST,
                    payload: _teamsData
                });
            } else if (_teamsData.userNotFound) {
                return dispatch({
                    type: Actions.RECEIVED_USER_NOT_FOUND_RESPONSE,
                    payload: _teamsData.message
                });
            }
        }
    }, [socialData, tsData]);

    useEffect(() => {
        if (data) {
            //console.log("got data", data);
            dispatch({
                type: Actions.RECEIVED_SESSION_DATA,
                payload: data
            });
        }
    }, [data]);

    const onSubmit = (_data) => {
        //console.log("dispatch", _data);
        const {username, password} = _data;
        setUserDetails(_data);
        teamStatsLogin(Object.assign({}, {username, password}, state.linkAccounts && state.linkAccounts.socialUser));
    };

    return (
        <>
            <div className="afs-msm-stage-content add-all-padding fx-container-y align-centre justify-centre">

                {(isSocialError || isTsError) &&
                <div className="afs-msm-text-input-error">Something went wrong ...</div>}

                {(isSocialLoading || isTsLoading || state.loginTeams && state.loginTeams.length === 1) ? (
                    <LoaderAnim/>
                ) : (
                    <>
                        {!state.linkAccounts && <div>
                            <Divider text="Use a social account"/>

                            <div className="fx-container-x fx-align-centre fx-justify-around">
                                <span className="third-width text-centre">Facebook</span>
                                <span className="third-width text-centre">Twitter</span>
                                <span className="third-width text-centre">Google</span>
                            </div>

                            <div className="fx-container-x fx-justify-between afs-msm-social-buttons-container">
                                <NavButton
                                    icon="facebook55"
                                    iconSize="30"
                                    iconFill="white"
                                    colour="#3B5999"
                                    className="afs-msm-inline-button btn fx-grow"
                                    onClick={() => {
                                        socialLogin("facebook", true);
                                    }}
                                />
                                <NavButton
                                    icon="twitter1"
                                    iconSize="30"
                                    iconFill="white"
                                    colour="#55ACEE"
                                    className="afs-msm-inline-button btn fx-grow add-horiz-margin"
                                    onClick={() => {
                                        socialLogin("twitter", true);
                                    }}
                                />
                                <NavButton
                                    icon="google"
                                    iconSize="30"
                                    iconFill="white"
                                    colour="#D34836"
                                    className="afs-msm-inline-button btn fx-grow"
                                    onClick={() => {
                                        socialLogin("google", true);
                                    }}
                                />
                            </div>
                            <Divider text="Or"/>
                        </div>}
                        {state.linkAccounts && <p>{state.linkAccounts.message}</p>}
                        <FormContext {...hookForm} >
                            <form onSubmit={hookForm.handleSubmit(onSubmit)}>
                                <FormInput
                                    type="text"
                                    name="username"
                                    label="Username or email address"
                                    errorText="Your user name or email address is required"
                                    validation={{required: true}}
                                    defaultValue={userDetails.username}
                                    autocorrect="off"
                                    autocapitalize="none"
                                />
                                <FormInput
                                    name="password"
                                    type="password"
                                    label="Password"
                                    errorText="Your password is required"
                                    validation={{required: true}}
                                    defaultValue={userDetails.password}
                                    autocorrect="off"
                                    autocapitalize="none"
                                    autocomplete="current-password"
                                />
                                {state.userNotFound && <p className="afs-msm-text-input-error">{state.userNotFound}</p>}
                                <NavButton
                                    className="afs-msm-inline-button btn"
                                    text="LOG IN"
                                    type="submit"
                                    onClick={hookForm.handleSubmit(onSubmit)}
                                />
                            </form>
                        </FormContext>
                    </>
                )}
            </div>
            <div className="afs-msm-stage-action-buttons">
                <NavButton
                    text="FORGOT PASSWORD?"
                    actionType={Actions.SELECTED_FORGOT_PASSWORD}
                />
            </div>
        </>
    );
};

export default {
    id: "login-method",
    title: "Log in to TeamStats",
    subtitles: [""],
    imageUrl:
        "https://www.teamstats.net/teamstats-media/images/signup-form/signup-header1.jpg",
    component: LoginMethod
};
